"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TopNavigationButtonsNames = void 0;
var mobx_react_1 = require("mobx-react");
var react_1 = __importDefault(require("react"));
var ActionButtons_1 = __importDefault(require("./ActionButtons"));
var icons_1 = require("@qwilr/kaleidoscope/icons");
var Types_1 = require("@CommonFrontendBackend/Projects/Types");
var Utils_1 = require("@CommonFrontendBackend/Projects/Utils");
var TelemetryEnums_1 = require("@CommonFrontend/Telemetry/TelemetryEnums");
var ManualPageValueModal_1 = require("Project/Actions/ManualPageValue/ManualPageValueModal");
var FeatureFlag_1 = __importDefault(require("@CommonFrontendBackend/FeatureFlag"));
var CommonUtils_1 = require("@CommonFrontendBackend/Utils/CommonUtils");
var PageEngagementEditorPopover_1 = require("./PopoverComponents/PageEngagementEditorPopover");
var TopNavigationButtonsNames;
(function (TopNavigationButtonsNames) {
    TopNavigationButtonsNames["PreviewPage"] = "Preview Page";
    TopNavigationButtonsNames["CollaboratorPreview"] = "Preview";
    TopNavigationButtonsNames["ShareWithTeam"] = "Share With Team";
    TopNavigationButtonsNames["DownloadPdf"] = "Download PDF";
    TopNavigationButtonsNames["Tokens"] = "Tokens";
    TopNavigationButtonsNames["ConvertToTemplate"] = "Create Template";
})(TopNavigationButtonsNames = exports.TopNavigationButtonsNames || (exports.TopNavigationButtonsNames = {}));
var ActionButtonsController = (function (_super) {
    __extends(ActionButtonsController, _super);
    function ActionButtonsController(props) {
        var _this = _super.call(this, props) || this;
        _this.getActionListItemForTokenPanel = function (_a) {
            var _b = _a === void 0 ? { showText: false } : _a, showText = _b.showText;
            return {
                name: TopNavigationButtonsNames.Tokens,
                icon: react_1.default.createElement(icons_1.Tokens, null),
                actionClass: "tokens",
                internalName: "tokens",
                text: showText ? "Tokens" : undefined,
                onClick: function () { },
            };
        };
        _this.getActionListItemForConvertToTemplate = function () {
            return {
                name: TopNavigationButtonsNames.ConvertToTemplate,
                icon: react_1.default.createElement(icons_1.Template, null),
                actionClass: "convert-to-template",
                internalName: "convertToTemplate",
                onClick: function () { },
            };
        };
        _this.getActionsList = function () {
            var hashExists = !!_this.projectStore.linkStore.collaboratorHash;
            var href = hashExists
                ? function () { return _this.projectStore.getCollaboratorPageUrl({ source: TelemetryEnums_1.TelemetrySource.Editor }); }
                : undefined;
            var onClickHandler = hashExists ? undefined : _this.generateThenOpenCollaboratorPage;
            var actionsList = [
                {
                    name: TopNavigationButtonsNames.CollaboratorPreview,
                    icon: react_1.default.createElement(icons_1.Preview, { className: "navigation-actions__preview-icon-grey" }),
                    actionClass: "preview",
                    internalName: "preview",
                    href: href,
                    onClick: onClickHandler,
                },
            ];
            if (_this.projectStore.isEditable) {
                if (_this.projectStore.isTemplate) {
                    actionsList = __spreadArray([_this.getActionListItemForTokenPanel({ showText: true })], __read(actionsList), false);
                }
                else if (_this.isAdminUser()) {
                    actionsList.push(_this.getActionListItemForConvertToTemplate());
                }
            }
            if (!_this.projectStore.isTemplate) {
                actionsList.push({
                    name: "Download PDF",
                    icon: react_1.default.createElement(icons_1.Download, null),
                    actionClass: "pdf",
                    internalName: "downloadPdf",
                    onClick: function (event) {
                        if (event != null) {
                            event.preventDefault();
                        }
                        return _this.pdfOverlay.show();
                    },
                });
            }
            return actionsList;
        };
        _this.generateThenOpenCollaboratorPage = function () { return __awaiter(_this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.projectStore.getCollaboratorPageUrlWithGeneration({ source: TelemetryEnums_1.TelemetrySource.Editor })];
                    case 1:
                        url = _a.sent();
                        window.open(url);
                        return [2];
                }
            });
        }); };
        _this.getMoreActionsList = function () {
            var _a = _this.props, pageQuoteTotalStore = _a.pageQuoteTotalStore, projectStore = _a.projectStore, modal = _a.modal;
            var isTemplate = projectStore.isTemplate, _id = projectStore._id, status = projectStore.status, engagement = projectStore.engagement;
            var pageActions;
            var middleActions = [];
            var adminActions = [];
            if (isTemplate) {
                pageActions = _this.getAllowedActions(["bluePrint"]);
            }
            else {
                pageActions = _this.getAllowedActions(["analytics", "tag", "clone", "archive", "bluePrint"]);
            }
            if (_this.permissionsService.isAllowed(_this.projectStore.userAction, "edit") &&
                (0, Utils_1.isActionAllowed)(_this.projectStore.status, Types_1.ProjectActions.Edit)) {
                middleActions = __spreadArray([], __read((0, CommonUtils_1.includeIf)(!_this.usingFeature(FeatureFlag_1.default.RefreshedNavigationMenu), [
                    {
                        name: "Navigation",
                        getDisplayName: function () { return "Navigation"; },
                        onClick: function () {
                            _this.props.projectNavigation.configure();
                        },
                    },
                ])), false);
                if (!isTemplate) {
                    middleActions.push({
                        name: "PageValue",
                        getDisplayName: function () { return "Page Value"; },
                        onClick: function () {
                            (0, ManualPageValueModal_1.showManualPageValueModal)(modal, projectStore, pageQuoteTotalStore);
                        },
                    });
                    middleActions.push({
                        name: "Engagement",
                        getDisplayName: function () { return "Engagement"; },
                        onClick: function () { },
                        customMenuComponent: function (optionMenuItemProps) {
                            return (react_1.default.createElement(PageEngagementEditorPopover_1.PageEngagementEditorPopover, { projectStore: projectStore, isAdmin: _this.isAdminUser(), optionMenuItemProps: optionMenuItemProps }));
                        },
                    });
                }
            }
            if (_this.isAdminUser()) {
                adminActions = [
                    {
                        name: "BrandSetup",
                        getDisplayName: function () { return "Brand setup"; },
                        onClick: function () {
                            _this.props.openBrandSetup();
                        },
                    },
                    {
                        name: "AccountSettings",
                        getDisplayName: function () { return "Account settings"; },
                        onClick: function () {
                            _this.props.angularState.go("settings", { section: "account" });
                        },
                    },
                ];
            }
            return __spreadArray(__spreadArray(__spreadArray(__spreadArray([], __read(pageActions), false), __read(middleActions), false), __read(adminActions), false), __read(_this.getAllowedActions(["delete"])), false);
        };
        _this.isMoreActionsDisabled = function () {
            if (!_this.permissionsService.isAllowed(_this.projectStore.userAction, "view")) {
                return {
                    disabled: true,
                    reason: "Only admins and the project owner can share with team",
                };
            }
            else {
                return {
                    disabled: false,
                };
            }
        };
        _this.projectStore = props.projectStore;
        _this.projectActions = props.projectActions;
        _this.permissionsService = props.permissionsService;
        _this.usingFeature = props.usingFeature;
        _this.pdfOverlay = props.pdfOverlay;
        return _this;
    }
    ActionButtonsController.prototype.render = function () {
        var dragStore = this.props.dragStore;
        return (react_1.default.createElement(ActionButtons_1.default, { getActionsList: this.getActionsList, getMoreActionsList: this.getMoreActionsList, inviteNewUserModal: this.props.inviteNewUserModal, apiBaseUrl: this.props.apiBaseUrl, isMoreActionsDisabled: this.isMoreActionsDisabled(), projectStore: this.projectStore, rootDataStore: this.props.rootDataStore, shouldDisableButtonAccess: this.props.disableButtonAccess, telemetry: this.props.telemetry, modal: this.props.modal, project: this.props.project, usingFeature: this.usingFeature, dragStore: dragStore, tokenStore: this.props.tokenStore }));
    };
    ActionButtonsController.prototype.getAllowedActions = function (actions) {
        return this.projectActions.getActions(actions, this.projectStore);
    };
    ActionButtonsController.prototype.isAdminUser = function () {
        return this.props.rootDataStore.userDataStore.isAdmin;
    };
    ActionButtonsController = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], ActionButtonsController);
    return ActionButtonsController;
}(react_1.default.Component));
exports.default = ActionButtonsController;
